import React from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import "./ImpactCasesSection.css";

import Story1 from "../assets/images/story1.png";
import Story2 from "../assets/images/story2.png";
import Story3 from "../assets/images/story3.png";
import Story4 from "../assets/images/dso.png"
import Story5 from "../assets/images/open.png"
import Story6 from "../assets/images/transport.png"
import Story7 from "../assets/images/metropolitan.png"

import { motion } from "framer-motion";

const ImpactCasesSection = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();


  const regionMap = {
    "europe": "Europe",
    "asia": "Asia",
    "north_america": "North America",

  };

  const rawFilter = searchParams.get("filter");
  

  const normalizedFilterKey = rawFilter 
    ? rawFilter.toLowerCase().replace(/[-\s]/g, '_') 
    : null;

  const handleClearFilter = () => {
    navigate(window.location.pathname); 
  };

  const allCases = [
    {
      id: 1,
      image: Story1,
      title: "XRenewable Partnership",
      year: "2025",
      location: "London",
      description: "AI for EV charging-site intelligence and renewable energy planning.",
      result: "Optimised placement for energy efficiency.",
      category: "Europe", 
    },
    {
      id: 2,
      image: Story2,
      title: "Ordnance Survey",
      year: "2025",
      location: "London",
      description: "InfraPlan pilot for national infrastructure planning.",
      result: "Improved site selection and data consistency.",
      category: "Europe", 
    },
    {
      id: 3,
      image: Story3,
      title: "TfL Go App",
      year: "2024",
      location: "London",
      description: "CityTwin model for real-time cycling route optimisation.",
      result: "21% better route accuracy, reduced congestion.",
      category: "Europe", 
    },
    {
      id: 4,
      image: Story4,
      title: "DSO Project",
      year: "2024-2025",
      location: "Singapore",
      description: "National digital twin integrating mobility, energy, and environment.",
      result: "Foundational infrastructure for resilient cities.",
      category: "Asia", 
    },
    {
    id: 5,
      image: Story5,
      title: "Open Crime Data",
      year: "2023",
      location: "Chicago",
      description: "AI-driven crime incident prediction model.",
      result: "Demonstrated cross-city model adaptability.",
      category: "North America", 
    },
    {
    id: 6,
      image: Story6,
      title: "Transport Bureau",
      year: "2024",
      location: "Shenzhen",
      description: "SafeCity half-hour accident-risk forecasting system.",
      result: "Operational results: higher accuracy and reduced incidentrate.",
      category: "Asia", 
    },
    {
    id: 7,
      image: Story7,
      title: "Metropolitan Police",
      year: "2023",
      location: "London",
      description: "SafeCity predictive patrol and hotspot mapping.",
      result: "Improved response efficiency and coverage.",
      category: "Europe", 
    }
  ];

  const displayedCases = normalizedFilterKey
    ? allCases.filter((item) => 
        item.category.toLowerCase().replace(/[-\s]/g, '_') === normalizedFilterKey
      )
    : allCases;

  const getDisplayName = (key) => {
    if (!key) return "";
    
    if (regionMap[key]) {
      return regionMap[key];
    }


    return key
      .split('_') 
      .map(word => word.charAt(0).toUpperCase() + word.slice(1)) 
      .join(' '); 
  };

  const displayLabel = getDisplayName(normalizedFilterKey) || rawFilter;

  return (
    <motion.section
      initial={{ opacity: 0.8, y: 80 }}
      whileInView={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.8, ease: "easeOut" }}
      viewport={{ once: false, amount: 0.3 }}
    >
      <div className="impact-cases-container">
        <h2 className="section-title-cases">Global Impact – Proven Across Cities and Continents</h2>
        <p className="subtitle">
          From London to Singapore, from Chicago to Shenzhen —<br />
          SpaceTimeAI delivers measurable results for safer, smarter, and more resilient cities.
        </p>

        {normalizedFilterKey && (
          <p className="subtitle" style={{ marginBottom: '20px', color: '#459BA7' }}>
            Showing results for: <strong>{displayLabel}</strong> 
            <span 
              onClick={handleClearFilter}
              style={{cursor: 'pointer', textDecoration: 'underline', marginLeft: '10px', fontSize: '0.9em'}}
            >
              (Clear Filter)
            </span>
          </p>
        )}

        <div className="cases-grid">
          {displayedCases.length > 0 ? (
            displayedCases.map((caseItem, index) => (
              <motion.div
                key={caseItem.id}
                className="case-card"
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ delay: index * 0.2, duration: 0.6 }}
                viewport={{ once: false }}
                layoutId={`card-${caseItem.id}`} 
              >
                <img src={caseItem.image} alt={caseItem.title} className="case-image" />
                <h3 className="case-title">{caseItem.title}</h3>
                <div className="case-meta">
                  <span>{caseItem.year} | {caseItem.location}</span>
                </div>
                <p className="case-desc">{caseItem.description}</p>
                <p className="case-result">
                  <span className="arrow">→</span> {caseItem.result}
                </p>
              </motion.div>
            ))
          ) : (
            <div style={{ gridColumn: '1 / -1', textAlign: 'center', padding: '40px' }}>
              <p>No success stories found for this category.</p>
              <button 
                onClick={handleClearFilter}
                style={{marginTop: '10px', padding: '8px 16px', background: '#459BA7', color: 'white', border: 'none', borderRadius: '6px', cursor: 'pointer'}}
              >
                View All Stories
              </button>
            </div>
          )}
        </div>
      </div>
    </motion.section>
  );
};

export default ImpactCasesSection;